import { gql } from 'apollo-boost';

import { ValidationErrorFragment, ValidationResultFragment, ValidationWarningFragment } from './common';

export const saveAdGroup = gql`
    mutation SaveAdGroup(
        $textAddInput: [GdAddTextAdGroupItemInput!]!
        $textUpdateInput: [GdUpdateTextAdGroupItemInput!]!
        $smartUpdateInput: [GdUpdatePerformanceAdGroupItemInput!]!
        $mcBannerUpdateInput: [GdUpdateMcBannerAdGroupItemInput!]!
        $contentPromotionAddInput: [GdAddContentPromotionAdGroupItemInput!]!
        $contentPromotionUpdateInput: [GdUpdateContentPromotionAdGroupItemInput!]!
        $login: String!
    ) {
        reqId: getReqId
        addTextAdGroups(input: { addItems: $textAddInput }) {
            addedAdGroupItems {
                adGroupId
            }
            validationResult {
                ...ValidationResultFragment
            }
        }
        updateTextAdGroup(input: { updateItems: $textUpdateInput }) {
            updatedAdGroupItems {
                adGroupId
            }
            validationResult {
                ...ValidationResultFragment
            }
        }
        updateSmartAdGroups(input: { updateItems: $smartUpdateInput }) {
            updatedAdGroupItems {
                adGroupId
            }
            validationResult {
                ...ValidationResultFragment
            }
        }
        updateMcBannerAdGroup(input: { updateItems: $mcBannerUpdateInput }) {
            updatedAdGroupItems {
                adGroupId
            }
            validationResult {
                ...ValidationResultFragment
            }
        }
        addContentPromotionAdGroups(input: { addItems: $contentPromotionAddInput }) {
            addedAdGroupItems {
                adGroupId
            }
            validationResult {
                ...ValidationResultFragment
            }
        }
        updateContentPromotionAdGroups(input: { updateItems: $contentPromotionUpdateInput }) {
            updatedAdGroupItems {
                adGroupId
            }
            validationResult {
                ...ValidationResultFragment
            }
        }
        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
    ${ValidationResultFragment}
`;

// todo @mrronuar удалить после закрытия тикета DIRECT-107659
export const createTextAdGroup = gql`
    mutation CreateTextAdGroup($textInput: GdAddTextAdGroupItemInput!, $login: String!) {
        reqId: getReqId
        addTextAdGroups(input: { addItems: [$textInput] }) {
            addedAdGroupItems {
                adGroupId
            }
            validationResult {
                ...ValidationResultFragment
            }
        }
        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
    ${ValidationResultFragment}
`;

export const addSmartFilters = gql`
    mutation AddSmartFilters($input: GdAddSmartFiltersInput!, $login: String!) {
        reqId: getReqId
        addSmartFilters(input: $input) {
            validationResult {
                errors {
                    ...ValidationErrorFragment
                }
                warnings {
                    ...ValidationWarningFragment
                }
            }
        }
        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
    ${ValidationErrorFragment}
    ${ValidationWarningFragment}
`;

export const deleteSmartFilters = gql`
    mutation DeleteSmartFilters($input: GdDeleteSmartFilterInput!, $login: String!) {
        reqId: getReqId
        deleteFilters(input: $input) {
            deletedItems {
                id
            }
            validationResult {
                errors {
                    ...ValidationErrorFragment
                }
            }
        }
        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
    ${ValidationErrorFragment}
`;

export const updateSmartFilters = gql`
    mutation UpdateSmartFilters($input: GdUpdateSmartFiltersInput!, $login: String!) {
        reqId: getReqId
        updateFilters(input: $input) {
            validationResult {
                errors {
                    ...ValidationErrorFragment
                }
                warnings {
                    ...ValidationWarningFragment
                }
            }
            updatedItems {
                id
            }
        }
        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
    ${ValidationErrorFragment}
    ${ValidationWarningFragment}
`;

export const createMcBannerAdGroup = gql`
    mutation CreateMcBannerAdGroup($mcBannerInput: GdAddMcBannerAdGroupItemInput!, $login: String!) {
        reqId: getReqId
        addMcBannerAdGroups(input: { addItems: [$mcBannerInput] }) {
            addedAdGroupItems {
                adGroupId
            }
            validationResult {
                errors {
                    ...ValidationErrorFragment
                }
                warnings {
                    ...ValidationWarningFragment
                }
            }
        }
        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
    ${ValidationErrorFragment}
    ${ValidationWarningFragment}
`;

export const createSmartAdGroup = gql`
    mutation CreateSmartAdGroup($smartInput: GdAddSmartAdGroupItemInput!, $login: String!) {
        reqId: getReqId
        addSmartAdGroups(input: { addItems: [$smartInput] }) {
            addedAdGroupItems {
                adGroupId
            }
            validationResult {
                errors {
                    ...ValidationErrorFragment
                }
                warnings {
                    ...ValidationWarningFragment
                }
            }
        }
        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
    ${ValidationErrorFragment}
    ${ValidationWarningFragment}
`;

export const updateInternalGroup = gql`
    mutation updateInternalAdGroups($internalInput: GdUpdateInternalAdGroupsInput!) {
        reqId: getReqId
        updateInternalAdGroups(input: $internalInput) {
            updatedAdGroupItems {
                adGroupId
            }
            validationResult {
                errors {
                    ...ValidationErrorFragment
                }
                warnings {
                    ...ValidationWarningFragment
                }
            }
        }
    }
    ${ValidationErrorFragment}
    ${ValidationWarningFragment}
`;

export const remoderateAdsCalloutsMutation = gql`
    mutation RemoderateAdsCallouts($input: GdRemoderateAdsCalloutsInput!, $login: String!) {
        reqId: getReqId
        remoderateAdsCallouts(input: $input) {
            processedAdGroupIds
            skippedAdGroupIds
            validationResult {
                errors {
                    ...ValidationErrorFragment
                }
                warnings {
                    ...ValidationWarningFragment
                }
            }
        }
        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
    ${ValidationErrorFragment}
    ${ValidationWarningFragment}
`;

export const addInternalGroups = gql`
    mutation addInternalAdGroups($internalInput: GdAddInternalAdGroupsInput!, $login: String!) {
        reqId: getReqId
        addInternalAdGroups(input: $internalInput) {
            addedAdGroupItems {
                adGroupId
            }
            validationResult {
                errors {
                    ...ValidationErrorFragment
                }
                warnings {
                    ...ValidationWarningFragment
                }
            }
        }
        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
    ${ValidationErrorFragment}
    ${ValidationWarningFragment}
`;

export const copyAdGroupsMutation = gql`
    mutation CopyAdGroupsMutation($input: GdCopyAdGroupsInput!, $login: String!) {
        copyAdGroups(input: $input) {
            copiedAdGroupIds
            validationResult {
                errors {
                    ...ValidationErrorFragment
                }

                warnings {
                    ...ValidationWarningFragment
                }
            }
        }

        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
    ${ValidationErrorFragment}
    ${ValidationWarningFragment}
`;

export const updateCpmAdGroup = gql`
    mutation UpdateCpmAdGroup($cpmInput: GdUpdateCpmAdGroupInput!, $login: String!) {
        reqId: getReqId
        saveCpmAdGroups(input: $cpmInput) {
            updatedAdGroupItems {
                adGroupId
            }
            validationResult {
                errors {
                    ...ValidationErrorFragment
                }
                warnings {
                    ...ValidationWarningFragment
                }
            }
        }
        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
    ${ValidationErrorFragment}
    ${ValidationWarningFragment}
`;

export const addContentPromotionAdGroupsMutation = gql`
    mutation AddContentPromotionAdGroupsMutation($contentPromotionInput: GdAddContentPromotionAdGroupInput!) {
        reqId: getReqId
        addContentPromotionAdGroups(input: $contentPromotionInput) {
            addedAdGroupItems {
                adGroupId
            }
            validationResult {
                ...ValidationResultFragment
            }
        }
    }
    ${ValidationResultFragment}
`;

export const updateContentPromotionAdGroupsMutation = gql`
    mutation UpdateContentPromotionAdGroups($contentPromotionInput: GdUpdateContentPromotionAdGroupInput!) {
        reqId: getReqId
        updateContentPromotionAdGroups(input: $contentPromotionInput) {
            updatedAdGroupItems {
                adGroupId
            }
            validationResult {
                ...ValidationResultFragment
            }
        }
    }
    ${ValidationResultFragment}
`;

export const updateAdGroupRegions = gql`
    mutation UpdateAdGroupRegions($input: GdUpdateAdGroupRegionsInput!) {
        reqId: getReqId
        updateAdGroupRegions(input: $input) {
            updatedAdGroupItems {
                adGroupId
            }
            skippedAdGroupIds
            validationResult {
                errors {
                    ...ValidationErrorFragment
                }
                warnings {
                    ...ValidationWarningFragment
                }
            }
        }
    }
    ${ValidationErrorFragment}
    ${ValidationWarningFragment}
`;
